import Image from 'next/image';
import { useState, FC, RefObject, ChangeEvent } from 'react';

import { assetsPath } from 'Data/constants';
// import { NavContext } from 'Context/nav-context';
import styles from './search-bar-mobile.module.scss';
import { useIntl } from 'react-intl';
import { getBannerHostUrl } from '@/utils';

interface SearchBarMobileProps {
  categories?: any[];
  searchBarRef?: RefObject<HTMLInputElement>;
}
export const setPopUpClass = (result: any, setPopup: any) => {
  if (result.length) {
    setPopup({ display: 'block' });
  } else {
    setPopup({ display: 'none' });
  }
};
const SearchBarMobile: FC<SearchBarMobileProps> = ({ categories = [], searchBarRef }) => {
  const [showPopup, setPopup] = useState({ display: 'block' });
  const [searchResult, setSearchResult] = useState<any[]>([]);
  // const { searchText } = useContext(NavContext);
  const [searchValue, setSearchValue] = useState<string>('');
  const { formatMessage } = useIntl();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);

    if (event.target.value === '') return null;
    const result: any = categories.filter((item: any) => {
      return item.L2L3.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setSearchResult(result);
    setPopUpClass(result, setPopup);
  };

  return (
    <div className={styles.lvl0NavSearchMobile}>
      <form
        id="nav-search"
        className={styles.level1NavSearchForm}
        action={`${getBannerHostUrl()}/search?text=${searchValue}`}
        autoComplete="off"
        noValidate
      >
        <input
          type="text"
          name="text"
          placeholder={formatMessage({ id: 'search' })}
          tabIndex={0}
          onChange={onChange}
          onBlur={() => {
            setPopup({ display: 'none' });
          }}
          value={searchValue}
          ref={searchBarRef}
        />
        <button type="submit">
          <Image
            src={`${assetsPath}/site-icons/2020-site-icons/ico-search.svg`}
            alt={formatMessage({ id: 'search' })}
            width={18}
            height={18}
          />
        </button>
      </form>
      <div className={styles.lvl0NavSearchDesktopPopup} style={showPopup}>
        {searchResult.map((result: any) => (
          <button key={result.L2L3} className={styles.searchPopupMbSearch} aria-label="searchInBeauty" tabIndex={0}>
            <div className={styles.searchPopupText}>
              <p>{result.L2L3}</p>
            </div>
            <div>
              {result.L0} / {result.L1}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBarMobile;
